
import { askApi } from '@/api/index'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { MARKET_CFG } from '@/websocket/quotationWebsocket'
const store = useStore()
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function addStock(e: any, row: any, loginInfo: { serverId: string, token: string }) {
  if (!e || !e.id) return
  const data: any = {}
  data.data = new FormData()
  // data.data.append('ids', route.query.serverid || route.query.serverId)
  data.data.append('ids', e.id)
  data.data.append('json', JSON.stringify([{
    eicode: '',
    securityNo: row.Inst || row.code,
    securityName: row.Name,
    securityMarket: row.Exch,
    exchange: row.Inst.toLocaleUpperCase() + 'A'
  }]))
  data.data.append('serverId', loginInfo.serverId)
  data.data.append('token', loginInfo.token)
  const _data: any = {
    ids: e.id,
    json: JSON.stringify([{
      eicode: '',
      securityNo: row.Inst || row.code,
      securityName: row.Name,
      securityMarket: row.Exch,
      exchange: row.Inst.toLocaleUpperCase() + 'A'
    }]),
    serverId: loginInfo.serverId,
    token: loginInfo.token
  }
  const _signature:any = []
  // 不兼容49版本谷歌
  // for (const key of data.data.keys()) {
  //   _signature.push(data.data.get(key))
  // }
  for (const key in _data) {
    _signature.push(_data[key])
  }
  const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
  data.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    timestamp: _time,
    signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
  }
  return askApi.addStock(data).then((res: any) => {
    if (res.code === 1) {
      // 通知原生
      window.open('gw://funccall?funcname=OnSelfStockChange')
    }
    return res.code
  })
}
// 删除自选
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function removeStock(ids: any, row: any, loginInfo: { serverId: string, token: string }) {
  const data: any = {}
  // data.data = {}
  data.data = new FormData()
  // data.data.append('ids', route.query.serverid || route.query.serverId)
  data.data.append('id', ids.join(','))
  data.data.append('json', JSON.stringify([{
    securityNo: row.Inst || row.code,
    securityName: row.Name,
    securityMarket: row.Exch
  }]))
  data.data.append('serverId', loginInfo.serverId)
  data.data.append('token', loginInfo.token)
  const _data: any = {
    id: ids.join(','),
    json: JSON.stringify([{
      securityNo: row.Inst || row.code,
      securityName: row.Name,
      securityMarket: row.Exch
    }]),
    serverId: loginInfo.serverId,
    token: loginInfo.token
  }
  const _signature:any = []
  // for (const key of data.data.keys()) {
  //   _signature.push(data.data.get(key))
  // }

  for (const key in _data) {
    _signature.push(_data[key])
  }
  const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
  data.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    timestamp: _time,
    signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
  }
  return askApi.deleteStock(data).then((res: any) => {
    if (res.code === 1) {
      // 通知原生
      window.open('gw://funccall?funcname=OnSelfStockChange')
    }
    return res.code
  })
}
// 获取自选分组列表
// 自选列表
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getzixuan(loginInfo: { serverId: string, token: string }) {
  const data: any = {}
  data.data = new FormData()
  /* {
    token: '5C16E8A05237C9BB4BDCCA78C93A6C55',
    serverId: '200'
  }
  */
  // const obj: any = {
  //   serverId: pageData.serverId,
  //   token: pageData.token
  // }
  store.commit('setLoginInfo', {
    token: loginInfo.token,
    serverId: loginInfo.serverId
  })
  data.data.append('serverId', loginInfo.serverId)
  data.data.append('token', loginInfo.token)
  const _data: any = {
    serverId: loginInfo.serverId,
    token: loginInfo.token
  }
  const _signature: any = []
  // for (const key of data.data.keys()) {
  //   _signature.push(data.data.get(key))
  // }
  for (const key in _data) {
    _signature.push(_data[key])
  }
  const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
  data.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    timestamp: _time,
    signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
  }
  askApi.getgroupall(data).then((res: any) => {
    if (res.data) {
      store.commit('setOptionalShareslist', res.data)
    }
  })
}
// 跳转至时分------合约详情
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function gotoDetail(row: any) {
  let url = ''
  if (row.Exch && row.Inst) {
    url = `gw://funccall?funcname=OnGoFenshi;param0=${row.Exch};param1=${row.Inst}`
    window.open(url)
  }
}
// 跳转至原生登录
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function gotoClientLogin() {
  window.open('gw://funccall?funcname=OnUserLogin')
}
// 跳转至K线
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function gotoKline(row: any, period?: string | undefined) {
  let url = ''
  if (row.Exch && row.Inst) {
    const periodstr = period || 'DAY'
    // periodstr 周期 1MIN，5MIN，15MIN，30MIN，60MIN，DAY，WEEK，MONTH，SEASON
    const Exch = row.Exch.toLocaleLowerCase() === 'sz' ? '0' : row.Exch.toLocaleLowerCase() === 'sh' ? '1' : '2'
    url = `gw://funccall?funcname=OnFireCommand;Command=kline.L2;param=<params><kline_special_event>0</kline_special_event><StyleName>JSFX</StyleName><code>${row.Inst}</code><market>${Exch}</market><periodstr>${periodstr}</periodstr><TabName>K线图</TabName><flag_container_style>K</flag_container_style><update_current_stock>1</update_current_stock></params>`
    // update_current_stock 为特殊参数，通知原生保存当前双击的股票，如后续页面不需要该参数，则改为可配置
    window.open(url)
  }
}


// 根据market id获取对应的键名
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getMarketKeyById(id: number | string): string | null {
  const idNum = typeof id === 'string' ? parseInt(id) : id
  
  // 遍历MARKET_CFG查找匹配的id
  for (const [key, value] of Object.entries(MARKET_CFG)) {
    if (value as any && typeof value === 'object' && 'id' in (value as any) && (value as any).id === idNum) {
      return key
    }
    
    // 处理嵌套的EUIDX情况
    if (key === 'EUIDX' && value && typeof value === 'object' && 'code' in value) {
      const euidxValue = value as { code: Record<string, { id: number }> }
      for (const [subKey, subValue] of Object.entries(euidxValue.code)) {
        if (subValue && subValue.id === idNum) {
          return subKey
        }
      }
    }
  }
  
  return null
}


/**
 * 百分比格式化：截断到2位小数，不四舍五入
 * @param val 小数形式的比率，如 0.1234 => '12.34%'
 */
function formatPctTrunc(val: number | null | undefined, suffix = '%'): string {
  if (val == null) return '--'
  const truncated = Math.trunc(val * 10000) / 100
  return truncated.toFixed(2) + suffix
} 

/**
 * 根据涨跌偏好返回股票涨跌的 CSS 类名
 *
 * preferGreenUptrendRedDowntrend（URL query 参数）：
 *   0 或不传 → 红涨绿跌（A股默认）：up=red, down=green
 *   1        → 绿涨红跌（港股/美股习惯）：up=green, down=red
 *
 * 返回值对应 CSS 类：
 *   'up'   → 涨色（由主题决定红/绿）
 *   'down' → 跌色（由主题决定绿/红）
 *   'flat' → 平盘色
 *
 * @param val  涨跌幅数值，null/undefined 视为平盘
 * @param prefer  URL query 中的 preferGreenUptrendRedDowntrend 值，'1' 表示绿涨红跌
 */
export function getStockClass(val: number | null | undefined, prefer?: string | null): string {
  if (val === undefined || val === null) return 'flat'
  if (val === 0) return 'flat'
  const greenUp = prefer === '1'
  if (val > 0) return greenUp ? 'up-green' : 'up'
  return greenUp ? 'down-red' : 'down'
}

/**
 * 跳转到分时图
 * @param fullCode 带市场后缀的股票代码，如 600848.SH / 03396.HK / AAPL.US
 */
export function jumpToStockChart(fullCode: string): void {
  const dotIdx = fullCode.lastIndexOf('.')
  const symbol = dotIdx > -1 ? fullCode.slice(0, dotIdx) : fullCode
  const market = dotIdx > -1 ? fullCode.slice(dotIdx + 1).toLowerCase() : ''
  const jumpUrl = `gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params>    <code>${symbol}</code>    <market_letter>${market}</market_letter>    <technique_type>0</technique_type>    <level2_orderchart_type>-1</level2_orderchart_type>    <StyleName>FSZS</StyleName>    <TabName>分时图</TabName>    <flag_container_style>R</flag_container_style></params>`
  window.open(jumpUrl)
}

// 返回上一级，离开当前页时调用，客户端会保存当前页面地址用于逐级返回
export function goFDBackPast(): void {
  const href = window.location.href.replace(/#/g, '')
  const queryStr = href.includes('?') ? href.split('?')[1] : ''
  const params = new URLSearchParams(queryStr)
  const isEmbed = params.get('isEmbed')
  // isEmbed: 0 弹窗式，1 嵌入式
  if (isEmbed === '1') {
    const url = `gw://backurl?param=${window.location.href}`
    window.open(url)
  }
}

export default {
  addStock,
  removeStock,
  getzixuan,
  gotoDetail,
  gotoClientLogin,
  gotoKline,
  getMarketKeyById,
  formatPctTrunc,
  goFDBackPast,
  jumpToStockChart,
}

export {
  addStock,
  removeStock,
  getzixuan,
  gotoDetail,
  gotoClientLogin,
  gotoKline,
  getMarketKeyById,
  formatPctTrunc,

}

/**
 * FDRouter - 封装 vue-router，在每次路由跳转前调用 goBackPast 记录历史堆栈
 */
import type { Router, RouteLocationRaw } from 'vue-router'

export class FDRouter {
  private router: Router

  constructor(router: Router) {
    this.router = router
  }

  push(to: RouteLocationRaw) {
    return this.router.push(to).then(res => { goFDBackPast(); return res })
  }

  replace(to: RouteLocationRaw) {
    return this.router.replace(to).then(res => { goFDBackPast(); return res })
  }

  back() {
    const result = this.router.back()
    goFDBackPast()
    return result
  }

  go(delta: number) {
    const result = this.router.go(delta)
    goFDBackPast()
    return result
  }
}
